var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuiz = function SvgQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 2.84C.94 1.82 1.4 1 2.06 1H15.3c.65 0 1.12.82 1.04 1.84l-.9 12.33c-.07 1.01-.66 1.83-1.3 1.83H3.21c-.65 0-1.24-.81-1.31-1.83L1 2.84Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.3 14.44a.83.83 0 1 0 0-1.67.83.83 0 0 0 0 1.67Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.3 10.68s.05-1.06.86-1.4c1.04-.46 1.65-1.35 1.65-2.03 0-1.33-1.12-2.41-2.5-2.41a2.46 2.46 0 0 0-2.51 2.4",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgQuiz;